import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';

export const EnquiryMemberGate = ({ kind }) => {
  const { pathname, search } = useLocation();
  const next = encodeURIComponent(`${pathname}${search}`);
  return (
    <div className="service-enquiry-form service-enquiry-gate" data-testid="enquiry-member-gate">
      <span className="service-enquiry-gate-icon" aria-hidden="true"><Lock size={20} strokeWidth={2} /></span>
      <h3>Sign in to {kind}</h3>
      <p>
        Enquiries are open to N3URO ACCESS members. Joining is free and takes a minute, and your
        details will be filled in for you automatically.
      </p>
      <div className="service-enquiry-gate-actions">
        <Link to={`/access/join?next=${next}`} className="service-enquiry-submit" data-testid="enquiry-gate-join">
          <span>Join free</span> <ArrowRight size={16} strokeWidth={2.4} />
        </Link>
        <Link to={`/access/sign-in?next=${next}`} className="subpage-btn-ghost" data-testid="enquiry-gate-signin">
          Sign in
        </Link>
      </div>
    </div>
  );
};

export default EnquiryMemberGate;
